import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image/withIEPolyfill'
import Layout from '../components/layout'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import styles from './blog-post.scss'
import defaultRTRenderOptions from "../../contentful/rich-text-renderer-options"
import Section from "../components/section/section";
import {buildBreadcrumbsItem, esaUrl, authorUrl} from "../helpers";

class EmotionalSupportAnimalTemplate extends React.Component {
  render() {
    const post = get(this.props, 'data.contentfulEmotionalSupportAnimal')
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const defaultImage = get(this.props, 'data.defaultImage.childImageSharp.fluid')
    const publisherName = get(this.props, 'data.site.siteMetadata.publisher.name')
    const options = {
      ...defaultRTRenderOptions
    }

    let breadcrumbTitle = post.breadcrumbTitle ? post.breadcrumbTitle : post.title

    const breadcrumbs = [
      buildBreadcrumbsItem('Emotional Support Animal', esaUrl()),
      buildBreadcrumbsItem(breadcrumbTitle, this.props.location.href)
    ]

    let seoComponents = []

    let postTitle = post.title

    if (post.seoTitle) {
      seoComponents.push(<meta name="title" content={ post.seoTitle } />)
      postTitle = post.seoTitle
    }
    if (post.metaDescription) {
      seoComponents.push(<meta name="description" content={ post.metaDescription.childMarkdownRemark.internal.content }  />)
    }
    if (post.canonicalUrl) {
      seoComponents.push(<link rel="canonical" href={ post.canonicalUrl } />)
    }
    if (post.schemaOrgJson) {
      seoComponents.push(<script type="application/ld+json">{ post.schemaOrgJson.internal.content }</script>)
    }

    seoComponents.unshift((<title>{ postTitle }</title>))

    const postH1 = get(post, 'hideTitle', false) ? `` : (<h1 itemProp="headline">{ post.title }</h1>)

    return (
      <Layout breadcrumbs={breadcrumbs} location={this.props.location} containerClassNames={`blog-post mt-5 pb-5 ${post.slug} blog_post-${post.contentful_id}`}>
        <Helmet>
          {seoComponents.map((component) => component)}
        </Helmet>
        <Section className="px-0">
          <div className="row">
            <div className="col-10 col-md-6 mx-auto" itemScope itemType="https://schema.org/BlogPosting">
              <meta itemProp="datePublished" content={ post.createdAt } />
              <meta itemProp="dateModified" content={ post.updatedAt } />
              {postH1}
              { post.author ? (
                <div className="blog-data col-12 col-md-8 mt-4 mb-5 mx-auto text-center">Reviewed by:
                  <a href={authorUrl(post.author)} rel="author" className="blog-author">{post.author.name}, {post.author.title}</a>
                  <div itemProp="author" itemScope itemType="https://schema.org/Person">
                    <meta itemProp="name" content={ post.author.name } />
                    <meta itemProp="honorificSuffix" content={ post.author.title } />
                  </div>
                </div>
              ) : ''}
              { publisherName ? (
                <link itemProp="publisher" href={ `#${publisherName.replace(' ', '')}Org` } />
              ) : ''}
              <div itemProp="articleBody">
                {documentToReactComponents(post.body.json, options)}
              </div>
              <meta itemProp="image" content={ post.heroImage ? post.heroImage.fixed.src : defaultImage.src } />
            </div>
          </div>
        </Section>
      </Layout>
    )
  }
}

export default EmotionalSupportAnimalTemplate

export const EmotionalSupportAnimalQuery = graphql`
  query EmotionalSupportAnimalBySlug($slug: String) {
    site {
      siteMetadata {
        title
        publisher {
          name
        }
      }
    }
    contentfulEmotionalSupportAnimal(slug: {eq: $slug}) {
      contentful_id
      title
      slug
      hideTitle
      seoTitle
      breadcrumbTitle
      metaDescription {
        childMarkdownRemark {
          internal {
            content
          }
        }
      }
      canonicalUrl
      schemaOrgJson {
        internal {
          content
        }
      }
      publishDate(formatString: "MMMM Do, YYYY")
      tags
      body {
        json
      }
      createdAt
      updatedAt
      author {
        name
        title
      }
    }
    defaultImage: file(relativePath: { eq: "logo.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
